const SubMenu = {

    // FIELDS
    "name": "Pangalan",
    "description": "Paglalarawan",
    "sub_menu_icon": "Icon",
    "main_menu": "Pangunahing Menu",
    "priority": "Prayoridad",
    "search": "Maghanap",

    // PAGE HEADER
    "sub_menu": "Sub Menu",

    // ERROR
    "error_name": "Ilagay ang Pangalan",
    "error_desc": "Ilagay ang Paglalarawan",
    "error_priority_positive": "Dapat Maging Positibo ang Prayoridad",
    "error_priority_required": "Ilagay ang Prayoridad",
    "error_priority_type_error": "Maglagay lamang ng Numero",
    "error_main_menu": "Piliin ang Pangunahing Menu",
    "error_icon": "Ilagay ang Pangalan ng Icon",

    // TABLE HEADER
    "table_name": "PANGALAN",
    "table_main_menu": "PANGUNAHING MENU",
    "table_description": "PAGLALARAWAN",
    "table_priority": "PRAYORIDAD",

}

export default SubMenu;